/** @jsx h */
import { labels } from '../config';

const ResultSummary = ({ allResultCount, resultIsEmpty, isError }) => {
  return (
    <span className="search-result__summary" aria-live="polite">
      {allResultCount === 0 ? (
        <div className="search-result__empty">
          {labels.results.nothingFound}
        </div>
      ) : isError ? (
        <div className="search-result__error">{labels.search.failed}</div>
      ) : allResultCount === 1 && allResultCount > 0 ? (
        `${allResultCount} ${labels.results.single}`
      ) : (
        `${allResultCount} ${labels.results.multiple}`
      )}
    </span>
  );
};

export default ResultSummary;
